var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.542 33.167 22 22.625Q20.75 23.75 19.125 24.333Q17.5 24.917 15.875 24.917Q12.042 24.917 9.396 22.271Q6.75 19.625 6.75 15.792Q6.75 11.958 9.396 9.313Q12.042 6.667 15.875 6.667Q19.667 6.667 22.354 9.313Q25.042 11.958 25.042 15.792Q25.042 17.5 24.417 19.125Q23.792 20.75 22.708 21.917L33.25 32.417ZM15.875 23.917Q19.333 23.917 21.688 21.583Q24.042 19.25 24.042 15.792Q24.042 12.333 21.688 10Q19.333 7.667 15.875 7.667Q12.458 7.667 10.104 10Q7.75 12.333 7.75 15.792Q7.75 19.25 10.104 21.583Q12.458 23.917 15.875 23.917Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f8b7deb2170398894ccab278b0bc36da.svg";
export { ForwardRef as ReactComponent };